import { z } from 'zod';

// form validation rules
export const ProductStatSchema = z.object({
  last_1: z.number(),
  last_7: z.number(),
  last_14: z.number(),
  last_30: z.number(),
  last_60: z.number(),
  last_90: z.number(),
  last_120: z.number(),
  last_150: z.number(),
  last_180: z.number(),
  last_365: z.number(),

  last_year_next_30: z.number(),
  last_year_next_60: z.number(),
  last_year_next_90: z.number(),
  last_year_next_120: z.number(),
  last_year_next_150: z.number(),
  last_year_next_180: z.number(),

  // Gross profit realized over the window, in dollars: each sale line's own
  // price less discount less cost, summed. Only the Popularity report's windows.
  profit_last_30: z.number(),
  profit_last_60: z.number(),
  profit_last_90: z.number(),
  profit_last_180: z.number(),
  profit_last_365: z.number(),

  days_on_hand: z.number(),

  avg_sales_interval: z.number(),
  sales_interval_stddev: z.number(),
  sale_day_count: z.number(),
});
